import MasterCardImgFlipParty from "../components/MasterCardImgFlipParty";
import MasterCardImgFlipSling from "../components/MasterCardImgFlipSling";
import MasterCardImgFlipTote from "../components/MasterCardImgFlipTote";


const AllProducts = () => {
    return (
        <>
        <MasterCardImgFlipTote/>
        <MasterCardImgFlipParty/>
        <MasterCardImgFlipSling/>
        </>
    );
}

export default AllProducts;